import { render, staticRenderFns } from "./CustomFieldTemplateSelectableValues.vue?vue&type=template&id=bc747158&scoped=true"
import script from "./CustomFieldTemplateSelectableValues.vue?vue&type=script&lang=js"
export * from "./CustomFieldTemplateSelectableValues.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldTemplateSelectableValues.vue?vue&type=style&index=0&id=bc747158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc747158",
  null
  
)

export default component.exports